import React from 'react';
import PanelLayout from './PanelLayout';
import { useAuth } from '../auth/AuthContext';
import { roleLabelFor } from '../auth/roles';
import { paths } from '../routes/paths';
import { ORGANISER_SECTIONS } from '../pages/organiser/sections';

// /organizer-dashboard/* : the same shell as the admin panel, with the organiser's sections
// (Figma: Dashboard, Events, Ticket types, Payouts, Reports, Broadcast, Company profile).
const APPROVED = 1; // organizers.applicationStatusCode

export default function OrganiserLayout() {
  const { user } = useAuth();
  // The card at the foot of the sidebar names the company and whether it is approved (Figma:
  // "Button Factory / Verified organiser"), falling back to the person when there is no company.
  const identity = {
    name: user.organizerName || user.fullName,
    subtitle: user.organizerStatusCode === APPROVED ? 'Verified organiser' : user.organizerName ? 'Awaiting approval' : roleLabelFor(user),
  };
  return <PanelLayout label="ORGANISER" sections={ORGANISER_SECTIONS} profilePath={paths.organiser.profile} fallbackTitle="Organiser" identity={identity} />;
}
